<template>
  <modal title="Post Filters" size="sm" ref="modal">
    <posts-toolbar
      :filters="filters"
      @update:filters="$emit('update:filters', $event)">
      <slot />
    </posts-toolbar>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import PostsToolbar from './PostsToolbar.vue';

export default defineComponent({
  emits: ['update:filters'],
  mixins: [ModalMixin],
  components: { PostsToolbar, Modal },
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
});
</script>
